import { Link } from "react-router-dom";
import { BookOpen, Receipt, Brain, ChevronRight, TrendingUp } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useLanguage } from "@/contexts/LanguageContext";

interface Guide {
  icon: typeof BookOpen;
  categoryKey: string;
  titleKey: string;
  snippetKey: string;
}

interface Guide {
  icon: typeof BookOpen;
  categoryKey: string;
  titleKey: string;
  snippetKey: string;
  path: string;
}

const GUIDES: Guide[] = [
  { icon: BookOpen, categoryKey: "guides.marketCat", titleKey: "guides.marketTitle", snippetKey: "guides.marketSnippet", path: "/guides/market-basics" },
  { icon: Receipt, categoryKey: "guides.taxCat", titleKey: "guides.taxTitle", snippetKey: "guides.taxSnippet", path: "/guides/tax-secrets" },
  { icon: Brain, categoryKey: "guides.wealthCat", titleKey: "guides.wealthTitle", snippetKey: "guides.wealthSnippet", path: "/guides/wealth-wisdom" },
];

export function ResourcesGuides() {
  const { t } = useLanguage();

  return (
    <section className="py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <div className="text-center mb-10">
          <h2 className="font-display text-2xl md:text-3xl font-bold text-foreground">
            {t("guides.sectionTitle")}
          </h2>
          <p className="mt-2 text-muted-foreground text-sm md:text-base max-w-xl mx-auto">
            {t("guides.sectionSub")}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
          {GUIDES.map((guide) => (
            <article key={guide.titleKey} className="clay p-5 md:p-6 flex flex-col gap-4">
              {/* Icon + Category */}
              <div className="flex items-center gap-2">
                <div className="h-9 w-9 rounded-lg bg-primary/10 flex items-center justify-center shrink-0">
                  <guide.icon className="h-5 w-5 text-primary" />
                </div>
                <span className="text-xs font-bold text-primary uppercase tracking-wider indic-text">
                  {t(guide.categoryKey)}
                </span>
              </div>

              {/* Title & Snippet */}
              <Link to={guide.path}>
                <h3 className="font-display text-base md:text-lg font-bold text-foreground leading-snug indic-text hover:text-primary transition-colors">
                  {t(guide.titleKey)}
                </h3>
              </Link>
              <p className="text-xs md:text-sm text-muted-foreground leading-relaxed flex-1 indic-text">
                {t(guide.snippetKey)}
              </p>

              {/* Vikas Score CTA */}
              <div className="pt-3 border-t border-border">
                <div className="flex items-center gap-2 mb-2">
                  <TrendingUp className="h-4 w-4 text-accent" />
                  <span className="text-xs font-semibold text-foreground">Vikas Score</span>
                </div>
                <p className="text-[11px] text-muted-foreground mb-3 indic-text">
                  {t("guides.cta")}
                </p>
                <div className="flex gap-2">
                  <Link to={guide.path} className="flex-1">
                    <Button size="sm" variant="outline" className="w-full gap-1 text-xs rounded-lg">
                      Read More <ChevronRight className="h-3 w-3" />
                    </Button>
                  </Link>
                  <Link to="/auth" className="flex-1">
                    <Button size="sm" className="w-full gap-1 text-xs rounded-lg">
                      Dashboard <ChevronRight className="h-3 w-3" />
                    </Button>
                  </Link>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
